import { useMediaQuery, Box, Typography, useTheme, Divider } from '@mui/material';
import { IEmergencyRegistration } from '../../../services/api/action-plan/EmergencyRegistration';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';

interface ISummaryRegister {
    data: IEmergencyRegistration
}

export const SummaryRegister = ({data}: ISummaryRegister) => {

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return(
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <Box>
                <Typography><strong>Informações do Simulado de Emergência</strong></Typography>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Acidente : </Typography>
                    <Typography>{data.acidente}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Causa : </Typography>
                    <Typography>{data.causa}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Ação : </Typography>
                    <Typography>{data.acoes}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Ação : </Typography>
                    <Typography>{data.consequencias}</Typography>
                </Box>

                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Descrição : </Typography>
                    <Typography>{data.descricao}</Typography>
                </Box>

                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data de acionamento : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_acionamento)}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data de encerramento : </Typography>
                    <Typography>{formatDateWhitoutHour(data.data_encerramento)}</Typography>
                </Box>
            </Box>
            <Divider/>
            <Box>
             <Typography><strong>Causa de acidente</strong></Typography>

                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Empresa : </Typography>
                    <Typography>{data.causas_acidente?.empresa_elaboradora}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>ART : </Typography>
                    <Typography>{data.causas_acidente?.art}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Data emissão : </Typography>
                    <Typography>{data.causas_acidente?.data_emissao}</Typography>
                </Box>
                <Box
                    sx={smDown?{display: 'flex', flexDirection: 'column', gap: '1', justifyContent: 'center', alignContent: 'center'} : {display: 'flex', flexDirection: 'row', gap: '5px'}}
                >
                    <Typography>Responsável técnico : </Typography>
                    <Typography>{data.causas_acidente?.responsavel_tecnico}</Typography>
                </Box>
            </Box>
        </Box>
    );
};